export default "__VITE_ASSET__McbfZnCK__"